import { render, staticRenderFns } from "./SalesRecord.vue?vue&type=template&id=6d0cdb2e&scoped=true"
import script from "./SalesRecord.vue?vue&type=script&lang=js"
export * from "./SalesRecord.vue?vue&type=script&lang=js"
import style0 from "./SalesRecord.vue?vue&type=style&index=0&id=6d0cdb2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0cdb2e",
  null
  
)

export default component.exports